export default __webpack_public_path__ + "static/media/01.34f63fda.png";